import { FieldSettings } from '@progress/kendo-react-data-tools'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { PlatformConfigurationFilterKey } from '../../api/Trading-Accounts/Types/PlatformConfigurationTypesDto'
import { BooleanFilter } from './BooleanFilter'
import { CompaniesFilter, PlatformFilter, ServerPublicNamesFilter } from './common.filter'

export const getTicketBrokeragePlatformConfigurationFields = (): FieldSettings[] => [
  {
    name: PlatformConfigurationFilterKey.TICKMILL_COMPANY,
    label: 'Tickmill Company',
    filter: CompaniesFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: PlatformConfigurationFilterKey.PLATFORM_TYPE,
    label: 'Platform Type',
    filter: PlatformFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: PlatformConfigurationFilterKey.SERVER,
    label: 'Live Server',
    filter: ServerPublicNamesFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: PlatformConfigurationFilterKey.DEMO_SERVER,
    label: 'Demo Server',
    filter: ServerPublicNamesFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: PlatformConfigurationFilterKey.WECLOME_SERVER,
    label: 'Welcome Server',
    filter: ServerPublicNamesFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: PlatformConfigurationFilterKey.MAM_SERVER,
    label: 'MAM Server',
    filter: ServerPublicNamesFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: PlatformConfigurationFilterKey.DYNAMIC_LEVERAGE,
    label: 'Dynamic Leverage',
    filter: BooleanFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
]
